var _rect, _rect2, _text;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEzLogoUltraThin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    fill: "#000000"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 40,
    width: 120,
    height: 120,
    fill: "none",
    stroke: "#D4AF37",
    strokeWidth: 0.75
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 110,
    fontFamily: "Montserrat, sans-serif",
    fontSize: 80,
    textAnchor: "middle",
    dominantBaseline: "middle",
    fill: "none",
    stroke: "#D4AF37",
    strokeWidth: 0.75
  }, "\n    EZ\n  ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEzLogoUltraThin);
export default __webpack_public_path__ + "static/media/ez-logo-ultra-thin.c4e8fad09ff5a576be0e4f2c9550c8be.svg";
export { ForwardRef as ReactComponent };